import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { EntityConfig } from '../_appCommon/base/EntityConfig';
import { EntityDataServiceBase } from '../_appCommon/base/EntityDataServiceBase';
import { UrlQueryDef } from '../_appCommon/base/UrlQueryDef';

@Injectable()
export class CaseStageDataService extends EntityDataServiceBase
{
  constructor(protected http: HttpClient)
  {
    super(http, 'casestage');
  }

  protected loadEntityConfig(): void
  {
    this.entityConfig = new EntityConfig();

    this.entityConfig.entityDisplayName = 'casestage';
    this.entityConfig.apiUrl = 'api/CaseStage';
  }

  public updateListCaseStageOrder(caseStages: any[]): Observable<{}>
  {
    let queryDef = new UrlQueryDef();
    const observable = this.http.put(this.createUrl('updateListOrder'), { caseStageList: caseStages }, queryDef.getRequestConfig(true)).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }

  public updateListCaseStageManufactured(caseStageNumbers: any[], caseId: number): Observable<{}>
  {
    let queryDef = new UrlQueryDef();
    const observable = this.http.put(this.createUrl('updateListManufactured'), { caseStageList: caseStageNumbers, caseId }, queryDef.getRequestConfig(true)).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }

  public updateStatus(body: any): Observable<{}>
  {
    let queryDef = new UrlQueryDef();
    let observable = this.http.put(this.createUrl('updateStatus'), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public updateAligners(body: any): Observable<{}>
  {
    let queryDef = new UrlQueryDef();
    const observable = this.http.put(this.createUrl('updateAligners'), body, queryDef.getRequestConfig(true)).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }

  public sendMoveToStageReceivedStatusEmail(body: any): Observable<{}>
  {
    let queryDef = new UrlQueryDef();
    let observable = this.http.post(this.createUrl('sendMoveToStageReceivedStatusEmail'), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public getLastCaseStageCreated(queryDef:UrlQueryDef): Observable<any>{
    let observable = this.http.get(this.createUrl('getLastCaseStageCreated'), queryDef.getRequestConfig(false)).pipe(share());
    return observable;
  }

  public reactivateCaseStage(body: any): Observable<{}>
  {
    let queryDef = new UrlQueryDef();
    let observable = this.http.put(this.createUrl('reactivateCaseStage'), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public updateCaseStageCustomerAddress(body: any): Observable<{}>
  {
    let queryDef = new UrlQueryDef();
    let observable = this.http.put(this.createUrl('updateCaseStageCustomerAddress'), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public getGetLastManufacturedCaseStageByCaseId(caseId: number): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    queryDef.params = {};
    queryDef.params['caseId'] = caseId;
    let observable = this.http.get(this.createUrl('getLastManufacturedCaseStageByCaseId'), queryDef.getRequestConfig(false)).pipe(share());
    return observable;
  } 
}

